<template>
  <div class="container">
    <div class="head">
      <img src="@/assets/back.png" style="padding: 10px" alt="返回" width="21" height="21" @click="back">
      <div>供应商</div>
      <div style="margin-right: 10px;color: #FE003B" @click="back">退出</div>
    </div>
    <div class="main">
      <div class="company">
        <div class="name">{{storeInfo.companyName}}</div>
        <div class="address">{{storeInfo.companyAddress}}</div>
        <div class="code">统一社会代码：{{storeInfo.code}}</div>
      </div>
      <div class="range">
        <div class="title">经营范围</div>
        <div class="content">
          <p>{{storeInfo.business}}</p>
        </div>
      </div>
      <div class="info">
        <div class="title">企业信息</div>
        <div class="content">
          <div class="item">
            <span class="name">企业法人</span>
            <span class="text">{{storeInfo.username}}</span>
          </div>
          <div class="item">
            <span class="name">法人性别</span>
            <span class="text">{{storeInfo.sex==0?'男':'女'}}</span>
          </div>
          <div class="item">
            <span class="name">联系人</span>
            <span class="text">{{storeInfo.name}}</span>
          </div>
          <div class="item">
            <span class="name">联系电话</span>
            <span class="text">{{storeInfo.tel}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="title">必备功能</div>
      <div class="content">
        <div class="item"
             @click="onNavigate('/business/purchase')">
          <div class="item-img"
               style=" background:linear-gradient(235deg,#FE9A01 0%,#F83A50 100%);">
            <img src="@/assets/business01.png"
                 alt=""
                 width="24"
                 height="24">
          </div>
          <div class="name">我的求购</div>
        </div>
        <div class="item"
             @click="onNavigate('/business/product/list')">
          <div class="item-img"
               style=" background:linear-gradient(235deg,#FFC601 0%,#FE9701 100%);">
            <img src="@/assets/business02.png"
                 alt=""
                 width="24"
                 height="24">
          </div>
          <div class="name">产品管理</div>
        </div>
        <div class="item"
             @click="onNavigate('/business/price')">
          <div class="item-img"
               style=" background:linear-gradient(235deg,#00D37A 0%,#69D200 100%);">
            <img src="@/assets/business03.png"
                 alt=""
                 width="24"
                 height="24">
          </div>
          <div class="name">批量报价</div>
        </div>
        <div class="item"
             v-if="storeInfo.isCash == 1"
             @click="onNavigate('/business/cash')">
          <div class="item-img"
               style="background: linear-gradient(201deg, rgb(105, 190, 255) 0%, rgb(114, 58, 248) 100%);">
            <img src="@/assets/business04.png"
                 alt=""
                 width="24"
                 height="24">
          </div>
          <div class="name">提现申请</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getShopApply} from '@/api/apply.js'
export default {
  name: "index",
  data () {
    return {
      isBack: false,
      storeInfo : {}
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    back(){
      this.$router.push({path: '/business/supplierLogin'})
      localStorage.removeItem("store")
      localStorage.removeItem("storeId")
    },
    onNavigate (url) {
      this.$router.push({
        path: url,
        query:{
          sid : localStorage.getItem('storeId')
        }
      })
    },
    getInfo () {
      getShopApply({ id: localStorage.getItem('storeId') }).then(response => {
        if (response.success) {
          this.storeInfo = response.data
          localStorage.setItem('store',JSON.stringify(this.storeInfo))
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding-top: 0px;
  background: #ededed;
  .head {
    background-color: #f3f3f3;
    height: 44px;
    line-height: 44px;
    opacity: 1;
    display: flex;
    justify-content: space-between;
  }
  .main {
    background: #ffffff;
    padding: 10px 12px;
    .company {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
      border-radius: 4px;
      padding: 13px 15px;
      .name {
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
      }
      .address {
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
        margin-top: 24px;
      }
      .code {
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
        margin-top: 10px;
      }
    }
    .range {
      margin-top: 24px;
      .title {
        height: 22px;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
      }
      .content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        .item {
          border: 1px solid rgba(199, 199, 199, 1);
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
          padding: 5px 10px;
          margin: 5px 10px 5px 0;
        }
      }
    }
    .info {
      margin-top: 15px;
      .title {
        height: 22px;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
      }
      .content {
        .item {
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          color: #666666;
          margin-top: 14px;
          .name {
            display: inline-block;
            width: 65px;
            margin-right: 19px;
            text-align: justify;
          }
          .text {
            display: inline-block;
            flex: 1;
          }
        }
      }
    }
  }
  .footer {
    margin-top: 4px;
    background: #ffffff;
    padding: 9px 12px;
    .title {
      height: 22px;
      font-size: 16px;
      font-weight: bold;
      line-height: 22px;
      color: rgba(51, 51, 51, 1);
    }
    .content {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin: 14px 0;
      .item {
        width: 57px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .item-img {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 46px;
          height: 46px;
          border-radius: 50%;
        }
        .name {
          width: 57px;
          height: 20px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          line-height: 20px;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/business/index.vue